
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const { t } = useTranslation();
  
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=Modern%20technology%20office%20with%20glass%20buildings%2C%20digital%20screens%20displaying%20financial%20data%20and%20payment%20systems%2C%20professional%20business%20environment%20with%20blue%20and%20white%20color%20scheme%2C%20clean%20minimalist%20design%2C%20futuristic%20fintech%20workspace%20with%20servers%20and%20computers%2C%20high-tech%20atmosphere&width=1920&height=1080&seq=hero-bg&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-6 w-full">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              onClick={() => scrollToSection('services')}
              className="bg-[#9F7B5B] hover:bg-[#8A6B4F]"
            >
              {t('hero.exploreSolutions')}
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              onClick={() => scrollToSection('investment')}
              className="border-[#9F7B5B] text-[#9F7B5B] hover:bg-[#9F7B5B] hover:text-white"
            >
              {t('hero.investmentPortfolio')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
